import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import { headersWithAuthWithoutBody } from "../APIHelpers/Responses";

export const projectMilestoneServices = {
  getProjectMilestoneData,
};

async function getProjectMilestoneData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getProjectMilestoneData/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getProjectMilestoneData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}
